import WelcomePopup from './WelcomePopup';

export default WelcomePopup;
